import { Drawer } from '@nebula/drawer';
import { TitleXLarge, TitleLarge500 } from '@nebula/global-styles';
import styled from 'styled-components';
import { tabletMin } from '../../constants';

const grey10 = ({ theme }: { theme: any }) => theme.color.ui.grey[10];

export const StyledDrawer = styled(Drawer)`
  background-color: ${grey10};
`;

export const DrawerContent = styled.div`
  display: flex;
  flex-direction: column;
`;

export const DrawerHeading = styled(TitleLarge500)`
  margin: 0.5rem 0;

  @media ${tabletMin} {
    ${TitleXLarge}
  }
`;

export const ActionCardContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  padding-top: 1.5rem;
  padding-left: 0.25rem;

  a,
  a:hover,
  a:focus,
  a:active,
  a:visited {
    text-decoration: none;
  }

  svg,
  img {
    margin-top: 0.3125rem;
  }
`;
